// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__XR2tY","box":"WorkspacesBox_box__tNdX_","node":"WorkspacesBox_node__1km0l"};